import { useState } from "react";
import ModalContext from "../context/modalContext";

const ModalProvider = ({ children }) => {
  //state variable
  const [isOpen, setIsOpen] = useState(false);
  const [code, setCode] = useState("");
  const [title, setTitle] = useState("");
  const [params, setParams] = useState({});

  //some handler

  /**
   * This function is use to open the right modal base on the code. user can handle the modal by using the modalAction function with his params.
   * @param {string} code
   * @param {string} title
   * @param {object} params
   * @param {function} modalAction
   */
  function handleOpenModal(code, title, params = undefined) {
    setIsOpen(true);
    if (code) setCode(code.toUpperCase());
    if (title) setTitle(title);
    if (params !== undefined) setParams(params);
  }

  /**
   * This function is used to close the modal
   * and reset the context to initial value
   */
  function handleClose() {
    setIsOpen(false);
    setCode("");
    setTitle("");
    setParams({});
  }

  //context value
  const contextValue = {
    isOpen,
    modalCode: code,
    modalTitle: title,
    modalParams: params,
    onClose: handleClose,
    handleOpenModal,
  };

  return (
    <ModalContext.Provider value={contextValue}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
